/**
 * Determines if a `KeyboardEvent`'s key pressed is `tab` *without* the `shift` modifier.
 * @param e KeyboardEvent to check.
 * @returns `True` if the key pressed is *exactly* `shift`, `false` otherwise.
 */
export function isTabOnly(e: KeyboardEvent): boolean {
	return e.key === 'Tab' && !e.shiftKey
}

/**
 * Determines if a `KeyboardEvent`'s key combination is `shift + tab`.
 * @param e KeyboardEvent to check.
 * @returns `True` if the key combination is *exactly* `shift + tab`, `false` otherwise.
 */
export function isShiftTab(e: KeyboardEvent): boolean {
	return e.key === 'Tab' && e.shiftKey
}
